export class DateHelper {
    static ToDateLocalString(date: Date, language: string): string {
        if (!language) {
            language = 'fr';
        }

        return (
            date.getDate() +
            ' ' +
            date.toLocaleString(language, { month: 'long' }) +
            ' ' +
            date.getFullYear()
        );
    }

    static IsValid(date: any): boolean {
        return (
            date &&
            Object.prototype.toString.call(date) === '[object Date]' &&
            !isNaN(date)
        );
    }
}
